import { render, staticRenderFns } from "./ICP.vue?vue&type=template&id=9257c76a&scoped=true&"
var script = {}
import style0 from "./ICP.vue?vue&type=style&index=0&id=9257c76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9257c76a",
  null
  
)

export default component.exports